import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { translations, LANGS, RTL_LANGS } from "@/lib/translations";
import api from "@/lib/api";

const I18nContext = createContext(null);

const SUPPORTED = LANGS.map((l) => l.code);

function detectInitialLang() {
  const saved = localStorage.getItem("ui_lang");
  if (saved && SUPPORTED.includes(saved)) return saved;
  const langs = navigator.languages || [navigator.language || "en"];
  for (const l of langs) {
    const code = (l || "").toLowerCase().startsWith("hmn") ? "hmn" : (l || "").slice(0, 2).toLowerCase();
    if (SUPPORTED.includes(code)) return code;
  }
  return "en";
}

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(detectInitialLang);
  const setLang = useCallback((l) => { localStorage.setItem("ui_lang", l); setLangState(l); }, []);
  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = RTL_LANGS.includes(lang) ? "rtl" : "ltr";
  }, [lang]);
  const [formsTotal, setFormsTotal] = useState(() => Number(localStorage.getItem("forms_total")) || 0);
  useEffect(() => {
    api.get("/forms/categories").then(({ data }) => {
      if (data?.total) { setFormsTotal(data.total); localStorage.setItem("forms_total", String(data.total)); }
    }).catch(() => {});
  }, []);
  const forms = formsTotal ? new Intl.NumberFormat(lang === "hmn" ? "en" : lang, { useGrouping: "always" }).format(formsTotal) : "1,000+";
  const t = useCallback(
    (key, params) => {
      let str = (translations[lang] && translations[lang][key]) ?? translations.en[key] ?? key;
      if (params) for (const k in params) str = str.split(`{${k}}`).join(String(params[k]));
      return str.split("{forms}").join(forms);
    },
    [lang, forms]
  );
  return <I18nContext.Provider value={{ lang, setLang, t, forms, formsTotal }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
